module.exports = __webpack_public_path__ + "img/video-link.b09d8c43.svg";